<template>
  <footer>
    <div class="header_box_all">
      <div class="header_box">
        <div>
          <router-link to="/">
            <p class="logo" />
          </router-link>
          <ul class="ul_nav">
            <li>
              <router-link :to="`/articles/`">asdsadasdasdas</router-link>
            </li>
          </ul>
          <div class="end-all">
            <div class="end-all-one">电话：1111111</div>
            <div class="end-all-one">邮编：710000</div>
            <div class="end-all-one">邮件：111111</div>
            <div class="end-all-one">地址：陕西省西安市高新区高新一路40号万科金域国际企业总部大厦A座11708室</div>
          </div>
          <div class="header_box1">
            <div class="header_box1-l">
              <img src="./images/c.png" alt="">
              <p>
                <span>版权所有：西安斯奈特信息科技有限公司</span>
                <el-link :underline="false" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备1111号</el-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';
import { systemConfig } from '@/api/member';
export default {
  data() {
    return {
      list: [
        {
          name: "学术招聘",
          path: "/positions"
        },
      ],
      systemConfig: {
        mobile: '',
        email: '',
        icp: '',
        service_license: '',
        service_photo: ''
      }
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  mounted() {
    this.getSyetemConfig()
  },
  methods: {
    async getSyetemConfig() {
      const { statusCode, data } = await systemConfig();
      if (statusCode === 0) {
        this.systemConfig = data;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header_box_all {
  width: 100%;
  min-width: 1200px;
  height: 300px;
  background: var(--background-color-footer);
}

.header_box {
  width: 1200px;
  height: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 60px;
  box-sizing: border-box;
}

.header_box1 {
  height: 80px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: block;
  width: 230px;
  height: 70px;
  background-size: 100% 100%;
}

ul {
  display: flex;
  align-items: center;
}

ul li a {
  font-size: 1rem;
  font-weight: 500;
  color: var(--white-text);
  display: block;
  padding: 0 30px;
  box-sizing: border-box;
  border-right: 1px solid var(--regular-border-color);
}

ul li:first-child a {
  display: block;
  padding-left: 0px !important;
}

ul li:last-child a {
  display: block;
  border: none !important;
}

ul li:hover a {
  font-size: 1rem;
  font-weight: 500;
  color: var(--primary-color) !important;
}

ul li.active2 a {
  font-size: 1rem;
  font-weight: 500;
  color: var(--primary-color) !important;
}

.end-all {
  display: flex;
  align-items: center;
  margin-top: 35px;
}

.end-all-one {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--placeholder-text-color);
  opacity: 0.6;
  margin-right: 20px;
}

.right-all {
  display: flex;
  justify-content: center;
}

.right-all-one {
  margin-right: 60px;
}

.right-all-one:last-child {
  margin-right: 0px !important;
}

.right-all-one img {
  width: 120px;
  height: 120px;
  display: block;
}

.right-all-one p {
  width: 120px;
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  color: var(--placeholder-text-color);
  margin-top: 20px;
}

.header_box1-l {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header_box1-l img {
  width: 16px;
  height: 16px;
  display: block;
  margin-right: 10px;
}

.header_box1-l p {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--white-text);
  line-height: 80px;
  opacity: 0.8;
  display: flex;
}
.header_box1-l p a{
  color: var(--white-text);
  margin-left: 30px;
}
.header_box1-r {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--white-text);
  line-height: 80px;
  opacity: 0.8;
}
</style>
